module.exports = __webpack_public_path__ + "img/img13.0750e581.svg";